import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { bateau, croisiere as croisiereAPI } from './api';
import MeteoWidget from './components/MeteoWidget';
import NavigationChoiceModal from './components/NavigationChoiceModal';
import './Dashboard.css';

function Dashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [bateaux, setBateaux] = useState([]);
  const [zone, setZone] = useState('manche');
  const [showNavigationChoice, setShowNavigationChoice] = useState(false);
  const [activeCroisiere, setActiveCroisiere] = useState(null);

  useEffect(() => {
    loadUser();
    loadBateaux();
  }, []);

  useEffect(() => {
    if (bateaux.length > 0 && bateaux[0]?.id) {
      loadActiveCroisiere();
    }
  }, [bateaux]);

  const loadUser = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      setUser(userData);
    } catch (err) {
      console.error(err);
    }
  };

  const loadBateaux = async () => {
    try {
      const response = await bateau.getAll();
      setBateaux(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  const loadActiveCroisiere = async () => {
    if (bateaux.length === 0) return;
    
    try {
      const response = await croisiereAPI.getActive(bateaux[0].id);
      setActiveCroisiere(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleNavigationClick = () => {
    if (bateaux.length === 0) {
      alert('Vous devez d\'abord créer un bateau');
      navigate('/bateaux');
      return;
    }
    
    setShowNavigationChoice(true);
  };

  const handleStartCroisiere = async (bateauId, nom, description, destinationJour) => {
    try {
      const response = await croisiereAPI.create(bateauId, nom, description);
      setActiveCroisiere(response.data);
      setShowNavigationChoice(false);
      
      // Démarrer la première navigation avec la destination du jour
      navigate(`/bateau/${bateauId}/navigation?croisiere=${response.data.id}&destination=${encodeURIComponent(destinationJour)}&autostart=true`);
    } catch (err) {
      console.error(err);
      alert('Erreur lors de la création de la croisière');
    }
  };

  const handleStartNavigationJournee = (bateauId, destination) => {
    setShowNavigationChoice(false);
    navigate(`/bateau/${bateauId}/navigation?destination=${encodeURIComponent(destination)}&autostart=true`);
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1>⚓ Bienvenue {user?.name || 'Skipper'} !</h1>
        <p className="date">{new Date().toLocaleDateString('fr-FR', { 
          weekday: 'long', 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        })}</p>
      </header>

      <MeteoWidget zone={zone} onChangeZone={setZone} />

      <div className="dashboard-actions">
        <div className="action-card">
          <h2>⛵ Navigation</h2>
          <p>Démarrer une sortie en mer</p>
          <button 
            className="btn btn-primary"
            onClick={handleNavigationClick}
          >
            🌊 Démarrer navigation
          </button>
        </div>
      </div>

      <div className="dashboard-boats">
        <h2>🛥️ Mes bateaux ({bateaux.length})</h2>
        {bateaux.length === 0 ? (
          <div className="empty-state">
            <p>Vous n'avez pas encore de bateau enregistré</p>
            <button 
              className="btn btn-outline"
              onClick={() => navigate('/bateaux')}
            >
              ➕ Ajouter un bateau
            </button>
          </div>
        ) : (
          <div className="boats-grid">
            {bateaux.map(b => (
              <div 
                key={b.id} 
                className="boat-card"
                onClick={() => navigate(`/bateau/${b.id}`)}
              >
                <h3>{b.nom}</h3>
                <p className="boat-type">
                  {b.type === 'voilier' && '⛵ Voilier'}
                  {b.type === 'moteur' && '🚤 Moteur'}
                  {b.type === 'catamaran' && '⛵ Catamaran'}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="dashboard-nav">
        <button onClick={() => navigate('/bateaux')} className="nav-btn">
          🛥️ Mes bateaux
        </button>
        <button onClick={() => navigate('/meteo')} className="dashboard-btn meteo-btn">
  🌊 Météo Marine
</button>
        <button onClick={() => navigate('/profil')} className="nav-btn">
          👤 Profil
        </button>
      </div>

      <NavigationChoiceModal
        show={showNavigationChoice}
        onClose={() => setShowNavigationChoice(false)}
        onStartCroisiere={handleStartCroisiere}
        onStartNavigationJournee={handleStartNavigationJournee}
      />
    </div>
  );
  <style>{`
        .meteo-btn {
          background: linear-gradient(135deg, #00d2ff 0%, #3a7bd5 100%);
          color: white;
          border: none;
          padding: 15px 30px;
          border-radius: 8px;
          font-size: 1.1rem;
          cursor: pointer;
          transition: all 0.3s;
        }
        
        .meteo-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 210, 255, 0.3);
        }
      `}</style>
}

export default Dashboard;